export * from "./ComponentHeading";
